import './technologies.css';
import { FaAngular, FaReact, FaJava, FaPython } from "react-icons/fa";

function Technologies() {
  return (
    <section id="technologies">
        <h1 className="section-header">Current Tech Stack</h1>
        <div className="tech-list">
          <FaAngular className="tech-icon" title="Angular" />
          <FaReact className="tech-icon" title="React" />
          <FaJava className="tech-icon" title="Java" />
          <FaPython className="tech-icon" title="Python" />
        </div>
    </section>
  )
}

export default Technologies